/*eslint-disable*/
import React, { useState } from 'react'
import { Button, Form as FormUi, Grid, Header, Table, Icon, Modal } from 'semantic-ui-react';
import { Field as Fieldmik, FieldArray } from 'formik';
import { Checkbox } from 'formik-semantic-ui';

import { MyNormalInput } from '../formikInput/input';
import LoadingPlaceholder from '../placeholder/loadingPlaceholder';



const TDSModal = (props) => {
    
    //ArrayHelper
    Array.prototype.sum = function (prop) {
        var total = 0
        for (var i = 0, _len = this.length; i < _len; i++) {
            total += this[i][prop]
        }
        return total
    }

    return (
        <Modal
            open={props.open}
            onClose={props.onClose}
            size="fullscreen"
        >
            <Header>Product TDS</Header>
            <Modal.Content>
                <FieldArray
                    name="tdsOnBills">
                        {({ push, remove, form }) => {

                            const { inititalValues, values } = form
                            const { tdsOnBills } = values

                            let tdsArray = []

                            tdsOnBills.map(billObj => billObj.bill_po_mapping.map(poObj => poObj.poDetails.map(productObj => tdsArray.push(productObj.chargeTDS))))

                            const finalTotal = Number(tdsArray.reduce((total, obj) =>  (parseFloat(obj) || 0) + parseFloat(total), 0)).toFixed(2) || "0.00"

                            values.tdsAmountModal = finalTotal

                            console.log("Final Total in TDS Modal ===>", finalTotal)
                            return (
                                <>
                                    <Table celled structured className="w3-small">
                                        <Table.Header>
                                            {console.log("TDS on Bills ", tdsOnBills)}
                                            <Table.Row >
                                                <Table.HeaderCell className="labelName p-bold-600">Bill No</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">PO No</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">Product Name</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">Taxable Amount</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">TDS%</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">TDS Amount</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">Charge TDS</Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>
                                        
                                        <Table.Body>
                                            { props.tdsLoading ? 
                                                <LoadingPlaceholder /> 
                                                :
                                                tdsOnBills && tdsOnBills.map((bill, billIndex) => {

                                                    

                                                    return (
                                                        <React.Fragment>
                                                            {
                                                                bill.bill_po_mapping.map((po, poIndex) => {

                                                                    const rowSpanLength = po.poDetails.length

                                                                    return(
                                                                        <React.Fragment key={po.poId}>
                                                                            
                                                                            {
                                                                                po.poDetails.map((product, productIndex) => {


                                                                                    product.tdsPercentage =  values.vendorPan && values.vendorPan[4] === "P" ? product.personalHUFPercent : product.otherPercent

                                                                                    product.tdsAmount = (product.tdsPercentage/100) * +product.taxableAmount

                                                                                    return(
                                                                                        <Table.Row verticalAlign="middle" key={productIndex}>
                                                                                           
                                                                                            { productIndex < 1 ?
                                                                                                <Table.Cell rowSpan={rowSpanLength}>
                                                                                                    {bill.billNo}                                                                       
                                                                                                </Table.Cell>
                                                                                            :
                                                                                            ""}
                                                                                            { productIndex < 1 ?
                                                                                                <Table.Cell rowSpan={rowSpanLength}>
                                                                                                    {po.poNumber}                                                                       
                                                                                                </Table.Cell>
                                                                                            :
                                                                                            ""}

                                                                                            
                                                                                            <Table.Cell>
                                                                                                {product.psDescription}
                                                                                            </Table.Cell>
                                                                                            <Table.Cell>
                                                                                                {product.taxableAmount}
                                                                                            </Table.Cell>
                                                                                            <Table.Cell>
                                                                                                {product.tdsPercentage}
                                                                                            </Table.Cell>
                                                                                            <Table.Cell>
                                                                                                {product.tdsAmount}
                                                                                            </Table.Cell>
                                                                                            <Table.Cell>
                                                                                                <Fieldmik 
                                                                                                    name={`tdsOnBills[${billIndex}].bill_po_mapping[${poIndex}].poDetails[${productIndex}].chargeTDS`} 
                                                                                                    value={tdsOnBills[billIndex].bill_po_mapping[poIndex].poDetails[productIndex].chargeTDS} 
                                                                                                    component={MyNormalInput}
                                                                                                    style={{ width: "100%"}}
                                                                                                />
                                                                                            </Table.Cell>

                                                                                        </Table.Row>
                                                                                    )

                                                                                })
                                                                            }
                                                                        </React.Fragment>
                                                                    )
                                                                })
                                                            }       
                                                        </React.Fragment>
                                                    )
                                                }
                                            )}
                                        </Table.Body>
                                    </Table>
                                    <Grid columns={3}>
                                        <Grid.Row className="p-2">
                                            <Grid.Column width={8} />
                                            <Grid.Column>
                                                <FormUi.Group>
                                                    <FormUi.Field>    
                                                        <Header as="label" floated="right" className="labelName" size="tiny">₹ {finalTotal ? finalTotal : ""} </Header>                                                                                                             
                                                    </FormUi.Field>
                                                    <FormUi.Field> 
                                                        <Header  as="label" floated="right" className="labelName p-bold-600" size="tiny">Total</Header>  
                                                    </FormUi.Field>
                                                </FormUi.Group>
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                </>
                            )}
                        }
                </FieldArray>    
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={props.onModalSubmit} color={'green'} size="mini">Ok</Button>
                <Button onClick={props.onClose} size="mini">Cancel</Button>
            </Modal.Actions>
        </Modal>
    )

}

export default TDSModal